<template lang="html">
  <section class="country_models">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="country_models_filters" class="mt-2 ml-4 mr-4">
                        <b-card>
              <p class="card-text">Filters</p>
              <template v-if="countryActive">
                <div>
                  <div class="row">
                    <div class="col-lg-2">Model name:</div><input type="text" class="col-lg-3" v-model="filter.id.model.modelcode" placeholder="Model name"/>
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2">Description:</div><input type="text" class="col-lg-3" v-model="filter.id.model.description" placeholder="Description"/>
                  </div>
                </div>
              </template>
              <template v-else>
                <div>
                  <div class="row">
                    <div class="col-lg-2">Country code:</div><input type="text" class="col-lg-3" v-model="filter.id.countryId" placeholder="Country code"/>
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2">Description:</div><input type="text" class="col-lg-3" v-model="filter.countryDesc" placeholder="Description"/>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-2">Default ADM:</div><input type="text" class="col-lg-3" v-model="filter.admDefault" placeholder="Default ADM"/>
                  </div>
                </div>
              </template>
              <hr>
              <div class="row mt-3">
                <div class="col-lg-2">Enabled (generic):</div><b-form-select class="col-lg-3" v-model="filter.commModelGenerallyActiveInCountry">
                  <b-form-select-option :value="null">---</b-form-select-option>
                  <b-form-select-option :value="true">Yes</b-form-select-option>
                  <b-form-select-option :value="false">No</b-form-select-option>
                </b-form-select>
                <div class="col-lg-1"></div>
                <div class="col-lg-2">ADM:</div><input type="text" class="col-lg-3" v-model="filter.adm" placeholder="ADM"/>
              </div>
              <b-button variant="primary" v-b-toggle.country_models_filters @click="search(idKey, from)"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title" id='file-input' >{{this.title}}</h4>
            </div>
            <div class="col-lg-5">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-4">
              <span class="float-right">
                <b-button variant="primary mr-1"  @click="back()"><i class="mdi mdi-arrow-left"></i>Back</b-button>              
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.country_models_filters><i class="mdi mdi-filter"></i></b-button>
              </span>
            </div>
            <b-table 
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="visibleFields"
              :per-page="perPage"
              :current-page="1"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > 
            <!-- isEnabledGenericCheckBox Buttons -->
              <template v-slot:cell(isEnabledGenericCheckBox)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.commModelGenerallyActiveInCountry" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Enabled (generic) to True" @click="data.item.commModelGenerallyActiveInCountry=true; toggleAndSaveEnabledGeneric(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Enabled (generic) to False" @click="data.item.commModelGenerallyActiveInCountry=false; toggleAndSaveEnabledGeneric(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>     
              <template v-slot:cell(adm)="data" lang="html">
                <p :class="!data.item.adm ? 'text-grey' : ''">{{data.item.adm ? data.item.adm : data.item.tabele}}</p>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(edit)="data" lang="html">
                <b-button size="sm" variant="primary" style="max-width: 2.875rem;" v-b-tooltip.hover title="Edit Country Model" v-b-modal.modal-edit @click="editCurItem(data.item)">
                  <i class="mdi mdi-pencil"></i>
                </b-button>
              </template>
              <b-tooltip target="tooltip-target-1" triggers="hover">                    
              </b-tooltip>
            </b-table>
            <b-modal id="modal-edit" title="Edit Country Model" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Modelcode*:</div>
                  <b-form-select v-model="curItem.modelcode" class="col-lg-3" disabled>
                    <b-form-select-option :value="curItem.modelcode">{{ curItem.modelcode }}</b-form-select-option>
                  </b-form-select>
                  <div class="col-lg-3">Country*:</div>
                  <b-form-select v-model="curItem.countryId" class="col-lg-3" disabled>
                    <b-form-select-option :value="curItem.countryId">{{curItem.countryId + ' - ' + curItem.countryDesc}}</b-form-select-option>
                  </b-form-select>
                  <div class="col-lg-3 mt-2">ADM:</div>
                  <b-form-select v-model="curItem.adm" class="col-lg-3 mt-2">
                    <b-form-select-option :value="null">Implicit ({{curItem.admDefault}})</b-form-select-option>
                    <b-form-select-option v-for="version in versions" :key="version.tabinf" :value="version.tabinf">{{ version.tabinf + ' - ' + version.tabdes }}</b-form-select-option>
                  </b-form-select>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Nota:</div><textarea class="col-lg-9" placeholder="Nota" v-model="curItem.nota"></textarea>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem);ok()">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import { mapActions, mapGetters } from "vuex";
import { MultiSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
  name: 'country_models',
  components: {
    MultiSelect
  },
  methods: {
    toggleAndSaveEnabledGeneric(item,visibilityValue) {
      this.saveCurItem(item);         
    },        
    back(){
      history.back();
    },
    editCurItem(item) {
      console.log('EDIT ITEM', item);

      this.curItem = {
        ...item,
        modelcode: item.modelcode || (item.id && item.id.model ? item.id.model.modelcode : null),
        countryId: item.id ? item.id.countryId : item.countryId,
        adm: item.adm || (item.id ? item.id.version : null),
        isNew: false
      };
    },
    saveCurItem(curItem) {
      window.curr = curItem
      var intLabObj =  curItem;
      var checkYear = true;

      if(intLabObj.adm  !=null) {
        if(intLabObj.adm.toString().length != 0) {
          if(intLabObj.adm.toString().length > 2) {
            checkYear = false;
              this.$bvModal.msgBoxOk("il campo ADM non deve superare i due caratteri", {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }
        }  
      }

      if(checkYear){
        if(curItem.countries && curItem.countries.length > 0) {
          this.setSpinnerStatus(true);
          curItem.countries.forEach(country => {
            var item = {id: {countryId: country, model: {modelcode: intLabObj.modelcode}, version: intLabObj.adm}, ...intLabObj};
        
            this.axios.put('/ccb/auth/api/countryModel/'+curItem.modelcode+'/'+country, item, this.authHeader)              
            .then(response => {
              this.setSpinnerStatus(false);
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
            })
          });       
          this.$bvModal.msgBoxOk(intLabObj.isNew ? "Created!" : "Updated!", {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          }).then(() => {
            this.fillSelects();
          });
        } else if(curItem.models && curItem.models.length > 0) {
          curItem.models.forEach(model => {
            var item = {id: {countryId: intLabObj.countryId, model: {modelcode: model}, version: intLabObj.adm}, ...intLabObj};

            this.axios.put('/ccb/auth/api/countryModel/'+model+'/'+curItem.countryId, item, this.authHeader)              
            .then(response => {
              this.setSpinnerStatus(false);
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
            })
          });       
          this.$bvModal.msgBoxOk(intLabObj.isNew ? "Created!" : "Updated!", {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          }).then(() => {
            this.fillSelects();
          });
        } else {
          this.setSpinnerStatus(true);
          var item = {id: {countryId: intLabObj.countryId, model: {modelcode: intLabObj.modelcode}, version: intLabObj.adm}, ...intLabObj};

          this.axios.put('/ccb/auth/api/countryModel/'+curItem.modelcode+'/'+curItem.countryId, item, this.authHeader)              
          .then(response => {
            this.setSpinnerStatus(false);
            this.$bvModal.msgBoxOk(intLabObj.isNew ? "Created!" : "Updated!", {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            }).then(() => {
              this.refreshTable();
            });
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          })
        }
    }
    },
    search(idKey,from) {
      var apiUrl;
      if (from == 'countries') {
        apiUrl = '/ccb/auth/api/countryModelAll/countryModelByCountry/';
      } else {
        apiUrl = '/ccb/auth/api/countryModel/countryModelByModel/';
      }

      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true); 
      var params = {page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc}
      
      this.axios  
      .post(apiUrl + idKey , this.filter, {params: params, ...this.authHeader})
        .then((response) => {
          window.datas = response.data;
          this.items = response.data.content;
          this.totalRowsResult=response.data.totalElements;
          this.setSpinnerStatus(false);
        });
    },
    refreshTable() {
      this.search(this.idKey,this.from);
    },
    fillSelects() {
      this.setSpinnerStatus(true);
      this.search(this.idKey,this.from);
      this.axios.get('/ccb/auth/fe/version/list', this.authHeader)
        .then((response) => {
          this.versions = response.data;
        });
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
    ]),
  },
  data () {
    return {
      filter: {id: {model: {modelcode: null, description: null}, countryId: null}, myrange: null, countryDesc: null, admDefault: null, commModelGenerallyActiveInCountry: null, commModelFrontendActiveInCountry: null, mxeActive: null, adm: null, myMinimum: null, myActive: null, mySecondary: null},
      models: [],
      allModels: [],
      selectedModels: [],
      countries: [],
      selectedCountries: [],
      versions: [],
      curItem: {},
      items: [],
      totalRowsResult: 0,
      currentPage:1,
      perPage:10,
      sortBy:'id',
      sortDesc: false,
      title: '',
      fieldsCountry:[       
        {
          key: 'modelcode',
          label: 'Model Name',
          sortable: false,
          visible : false          
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
          visible : false                    
        },
        {
          key: 'myrange',
          label: 'MY-range',
          sortable: false,
          visible : false                    
        },
        {
          key: 'countryId',
          label: 'Country Code',
          sortable: false,
          visible : true           
        },        
        {
          key: 'countryDesc',
          label: 'Description',
          sortable: false,
          visible : true           
        },    
        {
          key: 'tabele',
          label: 'Default AdM',
          sortable: false,
          visible : true           
        },                
        {
          key: 'isEnabledGenericCheckBox',
          label: 'Enabled (generic)',
          sortable: false,
          visible : true                    
        },       
        {
          key: 'adm',
          label: 'Adm',
          sortable: false,
          visible : true          
        },        
        {
          key: 'edit',
          label: '',
          sortable: false,
          visible : true   
        }                    
      ],
      fieldsModel: [
        {
          key: 'modelcode',
          label: 'Model Name',
          sortable: false,
          visible : true          
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
          visible : true                    
        },
        {
          key: 'myrange',
          label: 'MY-range',
          sortable: false,
          visible : true                    
        },
        {
          key: 'countryId',
          label: 'Country Code',
          sortable: false,
          visible : false           
        },        
        {
          key: 'isEnabledGenericCheckBox',
          label: 'Enabled (generic)',
          sortable: false,
          visible : true                    
        },       
        {
          key: 'adm',
          label: 'Adm',
          sortable: false,
          visible : true          
        },        
        {
          key: 'edit',
          label: '',
          sortable: false,
          visible : true   
        }                    
      ],
    }
  },
  computed: {
    visibleFields() {
      if (this.countryActive) {
        return this.fieldsModel.filter(field => field.visible)
      } else {
        return this.fieldsCountry.filter(field => field.visible)
      }
    },
    ...mapGetters([
      'authHeader'
    ])
  },
   watch: {
    currentPage(){
      this.refreshTable();
    },
    perPage(){
      this.refreshTable();
    },
    sortBy(){
      this.refreshTable();
    },
    sortDesc(){
      this.refreshTable();
    }
  },
  created() {
    this.from = this.$route.params.from;
    if (this.from == 'countries') {
      this.countryActive = true;
    } else {
      this.countryActive = false;
    }
  },
  mounted() {
    window.scoper = this

    this.title = this.$route.params.title;  
    this.idKey = this.$route.params.idKey;
    this.from = this.$route.params.from;

    this.fillSelects();
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.text-grey {
  color: grey;
  font-style: italic;
}
</style>
<style lang="scss">
.table {
  td, th {
    white-space: normal !important;
    word-break: break-word;
    text-align: center;
  }
}
</style>